module.exports = __webpack_public_path__ + "b7251ea47006b9e9f3a69f15d65b8d31.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/fedex_2020_chart.png
// module id = 1675
// module chunks = 0